import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import OwlImg from 'assets/images/Owl-outline-only.png';

const useStyles = makeStyles((theme) => ({
  emptyState: {
    maxWidth: theme.spacing(62.5),
    margin: '0 auto',
    display: 'flex',
    padding: theme.spacing(3, 3, 0, 3),
    alignItems: 'end',
    flexWrap: 'wrap',
  },
  emptyState_textContainer: {
    paddingBottom: theme.spacing(3),
  },
  emptyState__title: {
    fontSize: 23,
    marginBottom: theme.spacing(1.375),
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: 1.3,
    display: 'block',
    color: theme.palette.greyBlue['700'],
  },
  emptyState__content: {
    color: theme.palette.greyBlue['700'],
    maxWidth: theme.spacing(23.5),
  },
  emptyState__img: {
    marginLeft: 'auto',
  },
}));

const NoContentMessage = ({ title, content, className, ...props }) => {
  const classes = useStyles(props);

  return (
    <div className={clsx(classes.emptyState, className)} {...props}>
      <div className={classes.emptyState_textContainer}>
        <Typography component="h3" className={classes.emptyState__title}>
          {title}
        </Typography>
        <Typography className={classes.emptyState__content}>
          {content}
        </Typography>
      </div>
      <img alt="" src={OwlImg} className={classes.emptyState__img} />
    </div>
  );
};

NoContentMessage.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  className: PropTypes.string,
};

export default NoContentMessage;
